import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=22934ff4&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "../../less/more.less?vue&type=style&index=0&id=22934ff4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22934ff4",
  null
  
)

export default component.exports